import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useCompanyContext } from '../../../../contexts/Company';
import { useLinesContext } from '../../../../contexts/Lines';
import { ESellerStore } from '../../../../Types';
import { pathname } from '../../../../utils';
import { getHeader } from './utils/get-header';
import companyInfo from '../../../../themes/themes';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Container from '@material-ui/core/Container';
import Stepper from '../../../../components/Onboarding/BuildingBlocks/OnboardingWrapper';
import SellerIdPageLayout from '../../../../components/Onboarding/Company/SellerId';
import AmazonConnectPageLayout from '../../../../components/Onboarding/Company/AmazonConnect';
import Notes from '../../../../components/Onboarding/Company/SellerIdNotes';
import VerifySeller from '../../../../components/Onboarding/Company/VerifySeller';
import Tip from '../../../../components/Onboarding/BuildingBlocks/OnboardingToolTip';

const useStyles = makeStyles((theme: any) => ({
  details: { maxWidth: 1000, marginTop: theme.spacing(3) },
}));

const supportedStores = [ESellerStore.amazon];

export default function SellerId() {
  const history = useHistory();
  const classes = useStyles();
  const { business } = useCompanyContext();
  const { products } = useLinesContext();
  const [verifySellerName, setVerifySellerName] = useState(false);
  const [switchToSellerId, setSwitchToSellerId] = useState(false);
  const theme = process.env.REACT_APP_THEME;
  const amazonConnectEnabled = true;
  const renderAmazonConnect = amazonConnectEnabled && !switchToSellerId;

  useEffect(() => {
    if (business && !supportedStores.includes(business.sellerStore)) {
      history.push(pathname.onboarding.extras.storeUrl.url);
    }
  }, [business, history]);

  return (
    <>
      <Stepper
        title={getHeader({
          business,
          verifySellerName,
          renderAmazonConnect,
        })}
        hideContent={!(products && business)}
        headerWidth={800}
        contentWidth={800}
      >
        {verifySellerName && (
          <VerifySeller setVerifySellerName={setVerifySellerName} />
        )}
        {!verifySellerName &&
          (renderAmazonConnect ? (
            <AmazonConnectPageLayout
              setSwitchToSellerId={setSwitchToSellerId}
            />
          ) : (
            <SellerIdPageLayout setVerifySellerName={setVerifySellerName} />
          ))}
      </Stepper>
      {products && business && !verifySellerName && !renderAmazonConnect && (
        <Container className={classes.details}>
          <Notes />
          <Tip
            tooltip={`${companyInfo[theme].company} utilizes your Amazon Seller ID to improve your experience, and to ensure we are partnering with established, experienced online sellers. Any data obtained pertaining to sales, products or performance will be used by ${companyInfo[theme].company} solely for the purpose of creating your custom Growth Plan, and will not be disclosed to a third party without your permission.`}
            marginTop={5}
          />
        </Container>
      )}
    </>
  );
}
